import { CanActivateChildFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { map } from 'rxjs/operators';
import { getAccountDetails } from '@aaa/emember/store-account';
import { AccountStatus } from '../../../types';
import { MobileRenewActions } from '../../../store/mobile-renew';

export const onlyAccountStatusPending: CanActivateChildFn = () => {
  const store = inject(Store);

  return store.select(getAccountDetails).pipe(
    filter((accountDetails) => !!accountDetails),
    map((accountDetails) => {
      if (accountDetails?.status === AccountStatus.ACTIVE) {
        store.dispatch(MobileRenewActions.navigateTo({ status: 'error', errorCode: 'membershipIsNotPendingStatus' }));

        return false;
      }

      return true;
    }),
  );
};

export default onlyAccountStatusPending;
